import React from "react";
import styles from "./Composer.module.css";
import { Icon, Text } from "@zapier/design-system";
import { Button } from "@zapier/design-system-beta";

interface HeaderProps {
  onClose?: () => void;
  handleResetChat: () => void;
}

export const Header: React.FC<HeaderProps> = ({ handleResetChat }) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerTitle}>
        <svg
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.187683 7.95349H3.84169C5.96587 7.95349 7.68785 6.23151 7.68785 4.10734V0.453613H9.35451V4.10734C9.35451 6.23151 11.0765 7.95349 13.2007 7.95349H16.8546V9.62016H13.2007C11.0765 9.62016 9.35451 11.3421 9.35451 13.4663V17.1206H7.68785V13.4663C7.68785 11.3421 5.96586 9.62016 3.84169 9.62016H0.187683V7.95349Z"
            fill="url(#paint0_linear_8836_6884)"
          />
          <path
            d="M1.85435 14.2754L4.80063 11.3292L5.97914 12.5077L3.03286 15.4539L1.85435 14.2754Z"
            fill="url(#paint1_linear_8836_6884)"
          />
          <path
            d="M14.0091 2.1205L11.0628 5.06677L12.2414 6.24528L15.1876 3.29901L14.0091 2.1205Z"
            fill="url(#paint2_linear_8836_6884)"
          />
          <path
            d="M3.03274 2.12048L5.97901 5.06676L4.8005 6.24527L1.85422 3.29899L3.03274 2.12048Z"
            fill="url(#paint3_linear_8836_6884)"
          />
          <path
            d="M15.1877 14.2754L12.2414 11.3291L11.0629 12.5077L14.0092 15.4539L15.1877 14.2754Z"
            fill="url(#paint4_linear_8836_6884)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8836_6884"
              x1="1.52854"
              y1="0.453613"
              x2="15.5138"
              y2="17.1205"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBF6E" />
              <stop offset="0.26" stopColor="#FEA048" />
              <stop offset="0.39" stopColor="#FF7F24" />
              <stop offset="0.5" stopColor="#FF4F00" />
              <stop offset="0.61" stopColor="#FF5789" />
              <stop offset="0.74" stopColor="#F589DC" />
              <stop offset="1" stopColor="#C1B7FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_8836_6884"
              x1="1.52854"
              y1="0.453613"
              x2="15.5138"
              y2="17.1205"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBF6E" />
              <stop offset="0.26" stopColor="#FEA048" />
              <stop offset="0.39" stopColor="#FF7F24" />
              <stop offset="0.5" stopColor="#FF4F00" />
              <stop offset="0.61" stopColor="#FF5789" />
              <stop offset="0.74" stopColor="#F589DC" />
              <stop offset="1" stopColor="#C1B7FF" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_8836_6884"
              x1="1.52854"
              y1="0.453613"
              x2="15.5138"
              y2="17.1205"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBF6E" />
              <stop offset="0.26" stopColor="#FEA048" />
              <stop offset="0.39" stopColor="#FF7F24" />
              <stop offset="0.5" stopColor="#FF4F00" />
              <stop offset="0.61" stopColor="#FF5789" />
              <stop offset="0.74" stopColor="#F589DC" />
              <stop offset="1" stopColor="#C1B7FF" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_8836_6884"
              x1="1.52854"
              y1="0.453613"
              x2="15.5138"
              y2="17.1205"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBF6E" />
              <stop offset="0.26" stopColor="#FEA048" />
              <stop offset="0.39" stopColor="#FF7F24" />
              <stop offset="0.5" stopColor="#FF4F00" />
              <stop offset="0.61" stopColor="#FF5789" />
              <stop offset="0.74" stopColor="#F589DC" />
              <stop offset="1" stopColor="#C1B7FF" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_8836_6884"
              x1="1.52854"
              y1="0.453613"
              x2="15.5138"
              y2="17.1205"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBF6E" />
              <stop offset="0.26" stopColor="#FEA048" />
              <stop offset="0.39" stopColor="#FF7F24" />
              <stop offset="0.5" stopColor="#FF4F00" />
              <stop offset="0.61" stopColor="#FF5789" />
              <stop offset="0.74" stopColor="#F589DC" />
              <stop offset="1" stopColor="#C1B7FF" />
            </linearGradient>
          </defs>
        </svg>

        <Text type="SmallPrint2" color="TextInverted">
          AI Chat
        </Text>
      </div>
      <div className={styles.headerButtons}>
        <Button
          onPress={handleResetChat}
          aria-label="Reset chat"
          iconStart={<Icon name="arrowRefresh" />}
          variant="ghost"
          size="compact"
          className={styles.startOverButton}
        >
          Restart chat
        </Button>
      </div>
    </div>
  );
};
